
/**
 * 콘텐츠 타입
 */
export type CourseLectureContentType = typeof CourseLectureContentType[keyof typeof CourseLectureContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLectureContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
